import { createRenderLayout } from 'common-ui';

export const ItemStockLayout = createRenderLayout('item-stock', ['Display'] as const);
